exports.components = {
  "component---src-pages-compartilhar-index-tsx": () => import("./../../../src/pages/compartilhar/index.tsx" /* webpackChunkName: "component---src-pages-compartilhar-index-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

